.gn{color:var(--brand-primary);}